/**
 * Email Credentials Service
 * API calls for credential email workflow
 */
/**
 * Create email credentials service with injected HTTP functions
 */
export function createEmailCredentialsService(get, post) {
    /**
     * Search for a user by V5UserId to get their IdentityId
     */
    const searchUser = async (apiBase, v5UserId) => {
        try {
            const url = `${apiBase}/api/usermanagement/users?searchtext=${encodeURIComponent(v5UserId)}`;
            const response = await get(url);
            const users = response.data;
            if (!users || users.length === 0) {
                return null;
            }
            // Find exact match by Id field
            const exactMatch = users.find((u) => u.Id === v5UserId);
            const user = exactMatch || users[0];
            return {
                identityId: user.IdentityId,
                displayName: user.DisplayName,
            };
        }
        catch {
            return null;
        }
    };
    /**
     * Get the user's PerfectServe UPN (perfectserve.net domain)
     */
    const getPerfectServeUpn = async (apiBase, identityId) => {
        try {
            const url = `${apiBase}/api/identitymanagement/${identityId}/principalNames`;
            const response = await get(url);
            const principalNames = response.data;
            // Filter for perfectserve.net domain
            const psPrincipal = principalNames.find((pn) => pn.DomainName && pn.DomainName.includes("perfectserve.net"));
            return psPrincipal?.Upn || null;
        }
        catch {
            return null;
        }
    };
    /**
     * Send credential email to user
     */
    const sendCredentialEmail = async (apiBase, identityId, upn) => {
        try {
            const encodedUpn = encodeURIComponent(upn);
            const url = `${apiBase}/api/users/${identityId}/principalNames/${encodedUpn}/credentialEmails`;
            const body = {
                CcAddresses: [],
            };
            await post(url, body);
            return true;
        }
        catch {
            return false;
        }
    };
    return {
        searchUser,
        getPerfectServeUpn,
        sendCredentialEmail,
    };
}
